function removeEmptyElements(root) {
  if (!root?.children) return;
  const children = Array.from(root.children);
  for (const child of children) {
    removeEmptyElements(child);
    if (child.children.length === 0 && child.textContent.trim() === '') {
      child.remove();
    }
  }
}

document.querySelectorAll('section.code-block pre').forEach(pre => removeEmptyElements(pre));
document.querySelectorAll('section.good-to-know').forEach(section => removeEmptyElements(section));

function handleCopyCode(event) {
  const button = event.currentTarget;
  const section = button.closest('section.code-block');
  const code = section.querySelector('code');
  const clone = code.cloneNode(true);
  clone.querySelectorAll('.line-numbers-rows, .line-numbers-sizer').forEach(el => el.remove());
  navigator.clipboard.writeText(clone.textContent).then(() => {
    const original = button.textContent;
    button.textContent = 'Copied!';
    setTimeout(() => { button.textContent = original; }, 2000);
  });
}

document.querySelectorAll('section.code-block button.copy-code').forEach(button => {
  button.addEventListener('click', handleCopyCode);
});

// Share links
function initShareLinks() {
  const pageUrl = window.location.href.split('#')[0];

  document.querySelectorAll('section.quote').forEach(section => {
    const blockquote = section.querySelector('blockquote');
    if (!blockquote) return;

    let text = blockquote.textContent.trim() + '\n\n';
    const figcaption = section.querySelector('figcaption');
    if (figcaption) {
      text += ' - ' + figcaption.textContent.trim() + '\n\n';
    }

    const xLink = section.querySelector('.X-share');
    if (xLink) {
      const xUrl = new URL('https://x.com/intent/tweet');
      xUrl.searchParams.set('text', text);
      xUrl.searchParams.set('url', pageUrl);
      xUrl.searchParams.set('hashtags', 'Shopify');
      xLink.href = xUrl.toString();
      xLink.target = '_blank';
    }

    const linkedInLink = section.querySelector('.linked-in-share');
    if (linkedInLink) {
      const liUrl = new URL('https://www.linkedin.com/feed/');
      liUrl.searchParams.set('shareActive', 'true');
      liUrl.searchParams.set('text', text + pageUrl + '\n\n#Shopify');
      linkedInLink.href = liUrl.toString();
      linkedInLink.target = '_blank';
    }

    const copyLink = section.querySelector('.copy-share');
    if (copyLink) {
      copyLink.addEventListener('click', (e) => {
        e.preventDefault();
        navigator.clipboard.writeText(text + pageUrl).then(() => {
          copyLink.classList.add('copied');
          setTimeout(() => { copyLink.classList.remove('copied'); }, 2000);
        });
      });
    }
  });
}

initShareLinks();

// Initialization of TOC height

const tocContainer = document.querySelector('.article-content aside.toc .toc-container');
tocContainer.style.setProperty('--height', tocContainer.querySelector('nav').offsetHeight + tocContainer.querySelector('h2').offsetHeight + 30 + 'px');

// Table of contents toggle
document.querySelector('.article-content aside.toc h2').addEventListener('click', (event) => event.target.closest('.toc-container').classList.toggle('open'));

// Table of contents active state
document.querySelectorAll('aside.toc nav ol li a').forEach(link => {
  link.addEventListener('click', () => {
    document.querySelector('aside.toc nav ol li.selected')?.classList.remove('selected');
    link.parentElement.classList.add('selected');
  });

  // Makes clicking on the whole list item forward the click to the link
  link.parentElement.addEventListener('click', (e) => {
    if (e.target === link.parentElement) {
      link.click();
    }
  });
});

// Scroll-based TOC tracking
(function () {
  const tocLinks = document.querySelectorAll('aside.toc nav ol li a');
  if (!tocLinks.length) return;

  const headings = [];
  tocLinks.forEach(link => {
    const id = decodeURIComponent(link.getAttribute('href').slice(1));
    const heading = document.getElementById(id);
    if (heading) headings.push({ heading, link });
  });

  if (!headings.length) return;

  let isScrolling = false;
  let scrollTimer;

  tocLinks.forEach(link => {
    link.addEventListener('click', () => {
      isScrolling = true;
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => { isScrolling = false; }, 1000);
    });
  });

  document.addEventListener('scrollend', () => {
    clearTimeout(scrollTimer);
    isScrolling = false;
  });

  const observer = new IntersectionObserver(
    (entries) => {
      if (isScrolling) return;
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          document.querySelector('aside.toc nav ol li.selected')?.classList.remove('selected');
          const match = headings.find(h => h.heading === entry.target);
          if (match) match.link.parentElement.classList.add('selected');
        }
      });
    },
    { rootMargin: '0px 0px -60% 0px', threshold: 0 }
  );

  headings.forEach(({ heading }) => observer.observe(heading));
})();